import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  AnyAggridInput: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Json: { input: any; output: any; }
};

/** Type description */
export type ActivityLog = {
  __typename?: 'ActivityLog';
  activity_detail?: Maybe<ActivityLogDetailObject>;
  activity_type?: Maybe<ActivityType>;
  created_by?: Maybe<CreatorObject>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  document_type?: Maybe<ActivityLogDocumentType>;
  /** field description */
  id: Scalars['Int']['output'];
  reference_id?: Maybe<Scalars['Int']['output']>;
};

export type ActivityLogByRefereceIdInput = {
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogCopyObject = {
  __typename?: 'ActivityLogCopyObject';
  id?: Maybe<Scalars['Int']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogCopyObjectInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogCreateInput = {
  activity_detail: ActivityLogDetailObjectInput;
  activity_type: ActivityType;
  created_by: CreatorInputObject;
  document_type: ActivityLogDocumentType;
  reference_id: Scalars['Int']['input'];
};

export type ActivityLogDetailObject = {
  __typename?: 'ActivityLogDetailObject';
  added_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  attachment_list?: Maybe<Array<Scalars['String']['output']>>;
  copied_from?: Maybe<ActivityLogCopyObject>;
  copied_to?: Maybe<ActivityLogCopyObject>;
  curr_status?: Maybe<Scalars['String']['output']>;
  deleted_related_employee?: Maybe<ActivityLogRelatedEmployeeObject>;
  message?: Maybe<Array<Scalars['String']['output']>>;
  prev_status?: Maybe<Scalars['String']['output']>;
  updated_fields?: Maybe<Scalars['Json']['output']>;
};

export type ActivityLogDetailObjectInput = {
  added_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  attachment_list?: InputMaybe<Array<Scalars['String']['input']>>;
  copied_from?: InputMaybe<ActivityLogCopyObjectInput>;
  copied_to?: InputMaybe<ActivityLogCopyObjectInput>;
  curr_status?: InputMaybe<Scalars['String']['input']>;
  deleted_related_employee?: InputMaybe<ActivityLogRelatedEmployeeObjectInput>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  prev_status?: InputMaybe<Scalars['String']['input']>;
  secondary_operation?: InputMaybe<ActivityType>;
  updated_fields?: InputMaybe<Scalars['Json']['input']>;
};

export enum ActivityLogDocumentType {
  BillingNote = 'billing_note',
  CashSales = 'cash_sales',
  Contact = 'contact',
  CreditNote = 'credit_note',
  DeliveryOrder = 'delivery_order',
  DeliveryTrip = 'delivery_trip',
  DepositInvoice = 'deposit_invoice',
  GoodsAdjustment = 'goods_adjustment',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsReturn = 'goods_return',
  GoodsTransfer = 'goods_transfer',
  Item = 'item',
  Maintenance = 'maintenance',
  Promotion = 'promotion',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  Tire = 'tire',
  User = 'user',
  Vehicle = 'vehicle'
}

export type ActivityLogFindManyAggrid = {
  __typename?: 'ActivityLogFindManyAggrid';
  count: Scalars['Int']['output'];
  results: Array<ActivityLog>;
};

export type ActivityLogRelatedEmployeeObject = {
  __typename?: 'ActivityLogRelatedEmployeeObject';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogRelatedEmployeeObjectInput = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum ActivityType {
  Active = 'active',
  AddRelatedEmployee = 'add_related_employee',
  Approve = 'approve',
  Cancel = 'cancel',
  CancelPendingScan = 'cancel_pending_scan',
  ChangePassword = 'change_password',
  Comment = 'comment',
  Copy = 'copy',
  Create = 'create',
  CreateImporter = 'create_importer',
  Delete = 'delete',
  DeleteRelatedEmployee = 'delete_related_employee',
  Document = 'document',
  Edit = 'edit',
  EditImporter = 'edit_importer',
  EditPermission = 'edit_permission',
  Image = 'image',
  InActive = 'in_active',
  SaveDatePayment = 'save_date_payment',
  StatusChange = 'status_change'
}

export enum AdditionalDiscountType {
  Baht = 'baht',
  Percent = 'percent'
}

export type AddressInputObject = {
  address_contact_fax?: InputMaybe<Scalars['String']['input']>;
  address_contact_name?: InputMaybe<Scalars['String']['input']>;
  address_contact_phone?: InputMaybe<Scalars['String']['input']>;
  address_type?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  is_same_as_default_address?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  sub_district?: InputMaybe<Scalars['String']['input']>;
};

export type AddressObject = {
  __typename?: 'AddressObject';
  address_contact_fax?: Maybe<Scalars['String']['output']>;
  address_contact_name?: Maybe<Scalars['String']['output']>;
  address_contact_phone?: Maybe<Scalars['String']['output']>;
  address_type?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  is_same_as_default_address?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  sub_district?: Maybe<Scalars['String']['output']>;
};

export enum AggridArrayFilterType {
  Array = 'array'
}

export type AggridBooleanFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridBooleanFilterModelType>;
};

export enum AggridBooleanFilterModelType {
  Equals = 'equals',
  NotEqual = 'notEqual'
}

export type AggridDateFilterModelInput = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridDateFilterType>;
  type?: InputMaybe<AggridDateFilterModelType>;
};

export enum AggridDateFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridDateFilterType {
  Date = 'date'
}

export type AggridFloatFilterModelInput = {
  condition1?: InputMaybe<AggridFloatFilterModelInputCondition>;
  condition2?: InputMaybe<AggridFloatFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridFloatFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Float']['input']>;
  filterTo?: InputMaybe<Scalars['Float']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridGenericArrayFilterModelInput = {
  filterType?: InputMaybe<AggridArrayFilterType>;
  type?: InputMaybe<AggridGenericArrayFilterModelType>;
  values?: InputMaybe<Scalars['Any']['input']>;
};

export enum AggridGenericArrayFilterModelType {
  Equals = 'equals',
  Has = 'has',
  HasEvery = 'hasEvery',
  HasSome = 'hasSome',
  IsEmpty = 'isEmpty'
}

export enum AggridISimpleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export type AggridIntFilterModelInput = {
  condition1?: InputMaybe<AggridIntFilterModelInputCondition>;
  condition2?: InputMaybe<AggridIntFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export type AggridIntFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['Int']['input']>;
  filterTo?: InputMaybe<Scalars['Int']['input']>;
  filterType?: InputMaybe<AggridNumberFilterType>;
  type?: InputMaybe<AggridNumberFilterModelType>;
};

export enum AggridNumberFilterModelType {
  Blank = 'blank',
  Empty = 'empty',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  InRange = 'inRange',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  NotBlank = 'notBlank',
  NotEqual = 'notEqual'
}

export enum AggridNumberFilterType {
  Number = 'number'
}

export enum AggridObjectArrayFilterModelType {
  Every = 'every',
  None = 'none',
  Some = 'some'
}

export enum AggridObjectArrayFilterType {
  ObjectArray = 'objectArray'
}

export enum AggridOperatorFilter {
  And = 'AND',
  Or = 'OR'
}

export type AggridSetSingleFilterModelInput = {
  condition1?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  condition2?: InputMaybe<AggridSetSingleFilterModelInputCondition>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<AggridOperatorFilter>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export type AggridSetSingleFilterModelInputCondition = {
  filterType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AggridSetSingleFilterModelType>;
  values?: InputMaybe<Array<InputMaybe<Scalars['Any']['input']>>>;
};

export enum AggridSetSingleFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual'
}

export type AggridSortModelItem = {
  colId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortOrder>;
};

export type AggridSortModelItemInput = {
  colId: Scalars['String']['input'];
  sort: SortOrder;
};

export type AggridStringFilterModelInput = {
  condition1?: InputMaybe<AggridStringFilterModelInputCondition>;
  condition2?: InputMaybe<AggridStringFilterModelInputCondition>;
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  operator?: InputMaybe<AggridOperatorFilter>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export type AggridStringFilterModelInputCondition = {
  filter?: InputMaybe<Scalars['String']['input']>;
  filterTo?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<AggridTextFilterType>;
  mode?: InputMaybe<AggridStringModeOption>;
  type?: InputMaybe<AggridStringFilterModelType>;
};

export enum AggridStringFilterModelType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'endsWith',
  Equals = 'equals',
  NotBlank = 'notBlank',
  NotContains = 'notContains',
  NotEqual = 'notEqual',
  StartsWith = 'startsWith'
}

export enum AggridStringModeOption {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type AggridTemplateInput = {
  endRow?: InputMaybe<Scalars['Int']['input']>;
  filterModel?: InputMaybe<Scalars['Any']['input']>;
  sortModel?: InputMaybe<Array<AggridSortModelItemInput>>;
  startRow?: InputMaybe<Scalars['Int']['input']>;
};

export enum AggridTextFilterType {
  Text = 'text'
}

export type AttachmentInputObject = {
  attachment_name?: InputMaybe<Scalars['String']['input']>;
  uploaded_by?: InputMaybe<CreatorInputObject>;
  uploaded_date?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AttachmentObject = {
  __typename?: 'AttachmentObject';
  attachment_name?: Maybe<Scalars['String']['output']>;
  uploaded_by?: Maybe<CreatorObject>;
  uploaded_date?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BankAccountDetailInputObject = {
  account_number?: InputMaybe<Scalars['String']['input']>;
  branch?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BankAccountDetailObject = {
  __typename?: 'BankAccountDetailObject';
  account_number?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BinLocation = {
  __typename?: 'BinLocation';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse_level_3: WarehouseLevel3;
};

export type CompanyUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type Contact = {
  __typename?: 'Contact';
  account_creditor?: Maybe<Scalars['String']['output']>;
  account_debtor?: Maybe<Scalars['String']['output']>;
  address_list?: Maybe<Array<AddressObject>>;
  attachment_list?: Maybe<Array<AttachmentObject>>;
  bank_account_detail_list?: Maybe<Array<BankAccountDetailObject>>;
  billing_note_contact_person?: Maybe<Scalars['String']['output']>;
  billing_note_contact_phone?: Maybe<Scalars['String']['output']>;
  billing_note_duration?: Maybe<Scalars['Int']['output']>;
  business_type?: Maybe<Scalars['String']['output']>;
  business_type_detail?: Maybe<Scalars['String']['output']>;
  contact_channel_list?: Maybe<Array<ContactChannelObject>>;
  contact_person_list?: Maybe<Array<ContactPersonObject>>;
  created_by: CreatorObject;
  created_date: Scalars['DateTime']['output'];
  credit_request?: Maybe<Scalars['Float']['output']>;
  credit_request_duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  is_customer: Scalars['Boolean']['output'];
  is_supplier: Scalars['Boolean']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  last_updated_by?: Maybe<CreatorObject>;
  last_updated_date?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nick_name?: Maybe<Scalars['String']['output']>;
  payment_contact_person?: Maybe<Scalars['String']['output']>;
  payment_contact_phone?: Maybe<Scalars['String']['output']>;
  payment_credit_duration?: Maybe<Scalars['Int']['output']>;
  payment_duration?: Maybe<Scalars['Int']['output']>;
  payment_type_list?: Maybe<Array<Scalars['String']['output']>>;
  purchase_amount_per_month?: Maybe<Scalars['Float']['output']>;
  registered_capital?: Maybe<Scalars['Float']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  remark_status?: Maybe<Scalars['String']['output']>;
  required_purchase_item_type?: Maybe<Array<Scalars['String']['output']>>;
  sales_person_list?: Maybe<Array<SalesPersonObject>>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  tag_id_list?: Maybe<Array<Scalars['Int']['output']>>;
  tag_list?: Maybe<Array<Tag>>;
  taxpayer_id?: Maybe<Scalars['String']['output']>;
  title_name?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type ContactAggrid = {
  __typename?: 'ContactAggrid';
  count: Scalars['Int']['output'];
  results: Array<Contact>;
};

export type ContactChannelInputObject = {
  contact_channel_info?: InputMaybe<Scalars['String']['input']>;
  contact_channel_type?: InputMaybe<Scalars['String']['input']>;
};

export type ContactChannelObject = {
  __typename?: 'ContactChannelObject';
  contact_channel_info?: Maybe<Scalars['String']['output']>;
  contact_channel_type?: Maybe<Scalars['String']['output']>;
};

export type ContactCreateInput = {
  account_creditor?: InputMaybe<Scalars['String']['input']>;
  account_debtor?: InputMaybe<Scalars['String']['input']>;
  address_list?: InputMaybe<Array<AddressInputObject>>;
  attachment_list?: InputMaybe<Array<AttachmentInputObject>>;
  bank_account_detail_list?: InputMaybe<Array<BankAccountDetailInputObject>>;
  billing_note_contact_person?: InputMaybe<Scalars['String']['input']>;
  billing_note_contact_phone?: InputMaybe<Scalars['String']['input']>;
  billing_note_duration?: InputMaybe<Scalars['Int']['input']>;
  business_type?: InputMaybe<Scalars['String']['input']>;
  business_type_detail?: InputMaybe<Scalars['String']['input']>;
  contact_channel_list?: InputMaybe<Array<ContactChannelInputObject>>;
  contact_person_list?: InputMaybe<Array<ContactPersonInputObject>>;
  created_by?: InputMaybe<CreatorInputObject>;
  credit_request?: InputMaybe<Scalars['Float']['input']>;
  credit_request_duration?: InputMaybe<Scalars['Int']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  is_customer: Scalars['Boolean']['input'];
  is_supplier: Scalars['Boolean']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  name?: InputMaybe<Scalars['String']['input']>;
  nick_name?: InputMaybe<Scalars['String']['input']>;
  payment_contact_person?: InputMaybe<Scalars['String']['input']>;
  payment_contact_phone?: InputMaybe<Scalars['String']['input']>;
  payment_credit_duration?: InputMaybe<Scalars['Int']['input']>;
  payment_duration?: InputMaybe<Scalars['Int']['input']>;
  payment_type_list?: InputMaybe<Array<Scalars['String']['input']>>;
  purchase_amount_per_month?: InputMaybe<Scalars['Float']['input']>;
  registered_capital?: InputMaybe<Scalars['Float']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  remark_status?: InputMaybe<Scalars['String']['input']>;
  required_purchase_item_type?: InputMaybe<Array<Scalars['String']['input']>>;
  sales_person_list?: InputMaybe<Array<SalesPersonInputObject>>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  taxpayer_id?: InputMaybe<Scalars['String']['input']>;
  title_name?: InputMaybe<Scalars['String']['input']>;
  unique_id: Scalars['String']['input'];
};

export type ContactImportInput = {
  data: Array<ContactCreateInput>;
  import_mode: ContactImportMode;
  user_unique_id: Scalars['String']['input'];
};

export enum ContactImportMode {
  Create = 'create',
  Update = 'update'
}

export type ContactImportResult = {
  __typename?: 'ContactImportResult';
  detail?: Maybe<Scalars['Json']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactLocation = {
  __typename?: 'ContactLocation';
  last_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type ContactLocationInputObject = {
  last_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  unique_id: Scalars['String']['input'];
};

export enum ContactModelType {
  Contact = 'contact',
  Customer = 'customer',
  Supplier = 'supplier'
}

export type ContactPersonInputObject = {
  contact_channel_list?: InputMaybe<Array<ContactChannelInputObject>>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  nick_name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  title_name?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPersonObject = {
  __typename?: 'ContactPersonObject';
  contact_channel_list?: Maybe<Array<ContactChannelObject>>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  last_name?: Maybe<Scalars['String']['output']>;
  nick_name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  title_name?: Maybe<Scalars['String']['output']>;
};

export enum ContactReportType {
  Contact = 'contact',
  Customer = 'customer',
  Supplier = 'supplier'
}

export type ContactUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ContactUpdateUniput = {
  account_creditor?: InputMaybe<Scalars['String']['input']>;
  account_debtor?: InputMaybe<Scalars['String']['input']>;
  address_list?: InputMaybe<Array<AddressInputObject>>;
  attachment_list?: InputMaybe<Array<AttachmentInputObject>>;
  bank_account_detail_list?: InputMaybe<Array<BankAccountDetailInputObject>>;
  billing_note_contact_person?: InputMaybe<Scalars['String']['input']>;
  billing_note_contact_phone?: InputMaybe<Scalars['String']['input']>;
  billing_note_duration?: InputMaybe<Scalars['Int']['input']>;
  business_type?: InputMaybe<Scalars['String']['input']>;
  business_type_detail?: InputMaybe<Scalars['String']['input']>;
  contact_channel_list?: InputMaybe<Array<ContactChannelInputObject>>;
  contact_person_list?: InputMaybe<Array<ContactPersonInputObject>>;
  credit_request?: InputMaybe<Scalars['Float']['input']>;
  credit_request_duration?: InputMaybe<Scalars['Int']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  is_customer?: InputMaybe<Scalars['Boolean']['input']>;
  is_supplier?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_updated_by?: InputMaybe<CreatorInputObject>;
  name?: InputMaybe<Scalars['String']['input']>;
  nick_name?: InputMaybe<Scalars['String']['input']>;
  payment_contact_person?: InputMaybe<Scalars['String']['input']>;
  payment_contact_phone?: InputMaybe<Scalars['String']['input']>;
  payment_credit_duration?: InputMaybe<Scalars['Int']['input']>;
  payment_duration?: InputMaybe<Scalars['Int']['input']>;
  payment_type_list?: InputMaybe<Array<Scalars['String']['input']>>;
  purchase_amount_per_month?: InputMaybe<Scalars['Float']['input']>;
  registered_capital?: InputMaybe<Scalars['Float']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  remark_status?: InputMaybe<Scalars['String']['input']>;
  required_purchase_item_type?: InputMaybe<Array<Scalars['String']['input']>>;
  sales_person_list?: InputMaybe<Array<SalesPersonInputObject>>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  tag_id_list?: InputMaybe<Array<Scalars['Int']['input']>>;
  taxpayer_id?: InputMaybe<Scalars['String']['input']>;
  title_name?: InputMaybe<Scalars['String']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ContactView = {
  __typename?: 'ContactView';
  address_list?: Maybe<Array<Scalars['Json']['output']>>;
  billing_note_duration?: Maybe<Scalars['Int']['output']>;
  business_type?: Maybe<Scalars['String']['output']>;
  contact_channel_list?: Maybe<Array<Scalars['Json']['output']>>;
  contact_type?: Maybe<Array<Scalars['String']['output']>>;
  created_date?: Maybe<Scalars['DateTime']['output']>;
  credit_request_duration?: Maybe<Scalars['Int']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  last_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payment_credit_duration?: Maybe<Scalars['Int']['output']>;
  payment_duration?: Maybe<Scalars['Int']['output']>;
  sales_person_list?: Maybe<Array<Scalars['Json']['output']>>;
  status?: Maybe<Scalars['Int']['output']>;
  tag_list?: Maybe<Array<Scalars['String']['output']>>;
  taxpayer_id?: Maybe<Scalars['String']['output']>;
  unique_id: Scalars['String']['output'];
};

export type ContactViewAggrid = {
  __typename?: 'ContactViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<ContactView>;
};

export type CreatorInputObject = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreatorObject = {
  __typename?: 'CreatorObject';
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  last_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type GeneralExportInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ImageUrlInputObjectInput = {
  img_url?: InputMaybe<Scalars['String']['input']>;
  is_main_img?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageUrlObject = {
  __typename?: 'ImageUrlObject';
  img_url?: Maybe<Scalars['String']['output']>;
  is_main_img?: Maybe<Scalars['Boolean']['output']>;
};

export type InventorySetting = {
  __typename?: 'InventorySetting';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: InventorySettingType;
};

export enum InventorySettingType {
  Cate_1 = 'cate_1',
  Cate_2 = 'cate_2',
  Cate_3 = 'cate_3',
  Unit = 'unit'
}

export type Location = {
  __typename?: 'Location';
  contact: ContactLocation;
  coordinator_name: Scalars['String']['output'];
  coordinator_phone: Scalars['String']['output'];
  distance: Scalars['Float']['output'];
  drop_cost?: Maybe<Scalars['Float']['output']>;
  google_map_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  province: Scalars['String']['output'];
  region: Scalars['String']['output'];
  secondary_driver_cost?: Maybe<Scalars['Float']['output']>;
  shipping_cost?: Maybe<Array<ShippingCost>>;
  status?: Maybe<Scalars['Int']['output']>;
  unique_id: Scalars['String']['output'];
};

export type LocationAggrid = {
  __typename?: 'LocationAggrid';
  count: Scalars['Int']['output'];
  results: Array<Location>;
};

export type LocationCreateInput = {
  contact: ContactLocationInputObject;
  coordinator_name: Scalars['String']['input'];
  coordinator_phone: Scalars['String']['input'];
  distance: Scalars['Float']['input'];
  drop_cost?: InputMaybe<Scalars['Float']['input']>;
  google_map_url?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  province: Scalars['String']['input'];
  region: Scalars['String']['input'];
  secondary_driver_cost?: InputMaybe<Scalars['Float']['input']>;
  shipping_cost?: InputMaybe<Array<ShippingCostInputObject>>;
  status?: InputMaybe<Scalars['Int']['input']>;
  unique_id: Scalars['String']['input'];
};

export type LocationImportInput = {
  data: Array<LocationCreateInput>;
  import_mode: LocationImportMode;
  user_unique_id: Scalars['String']['input'];
};

export enum LocationImportMode {
  Create = 'create',
  UpdateLocation = 'update_location',
  UpdateShippingCost = 'update_shipping_cost'
}

export type LocationImportResult = {
  __typename?: 'LocationImportResult';
  detail?: Maybe<Scalars['Json']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export enum LocationReportType {
  Location = 'location'
}

export type LocationUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type LocationUpdateUniput = {
  contact: ContactLocationInputObject;
  coordinator_name: Scalars['String']['input'];
  coordinator_phone: Scalars['String']['input'];
  distance: Scalars['Float']['input'];
  drop_cost?: InputMaybe<Scalars['Float']['input']>;
  google_map_url?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  province: Scalars['String']['input'];
  region: Scalars['String']['input'];
  secondary_driver_cost?: InputMaybe<Scalars['Float']['input']>;
  shipping_cost?: InputMaybe<Array<ShippingCostInputObject>>;
  status?: InputMaybe<Scalars['Int']['input']>;
  unique_id: Scalars['String']['input'];
};

export type LocationView = {
  __typename?: 'LocationView';
  contact_full_name?: Maybe<Scalars['String']['output']>;
  contact_phone?: Maybe<Scalars['String']['output']>;
  contact_unique_id: Scalars['String']['output'];
  coordinator_name: Scalars['String']['output'];
  coordinator_phone: Scalars['String']['output'];
  distance: Scalars['Float']['output'];
  drop_cost?: Maybe<Scalars['Float']['output']>;
  four_wheel_chilled?: Maybe<Scalars['Float']['output']>;
  four_wheel_frozen?: Maybe<Scalars['Float']['output']>;
  google_map_url?: Maybe<Scalars['String']['output']>;
  head_chilled?: Maybe<Scalars['Float']['output']>;
  head_frozen?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  province: Scalars['String']['output'];
  region: Scalars['String']['output'];
  secondary_driver_cost?: Maybe<Scalars['Float']['output']>;
  shipping_cost?: Maybe<Array<ShippingCost>>;
  six_wheel_chilled?: Maybe<Scalars['Float']['output']>;
  six_wheel_frozen?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  ten_wheel_chilled?: Maybe<Scalars['Float']['output']>;
  ten_wheel_frozen?: Maybe<Scalars['Float']['output']>;
  unique_id: Scalars['String']['output'];
};

export type LocationViewAggrid = {
  __typename?: 'LocationViewAggrid';
  count: Scalars['Int']['output'];
  results: Array<LocationView>;
};

export type Mutation = {
  __typename?: 'Mutation';
  ContactCreate?: Maybe<Contact>;
  ContactDelete?: Maybe<Contact>;
  ContactUpdate?: Maybe<Contact>;
  ImportContact: ContactImportResult;
  ImportLocation: LocationImportResult;
  LocationCreate?: Maybe<Location>;
  LocationDelete?: Maybe<Location>;
  LocationUpdate?: Maybe<Location>;
};


export type MutationContactCreateArgs = {
  createInput: ContactCreateInput;
};


export type MutationContactDeleteArgs = {
  uniqueInput: ContactUniqueInput;
};


export type MutationContactUpdateArgs = {
  uniqueInput: ContactUniqueInput;
  updateInput: ContactUpdateUniput;
};


export type MutationImportContactArgs = {
  importInput: ContactImportInput;
};


export type MutationImportLocationArgs = {
  importInput: LocationImportInput;
};


export type MutationLocationCreateArgs = {
  createInput: LocationCreateInput;
};


export type MutationLocationDeleteArgs = {
  uniqueInput: LocationUniqueInput;
};


export type MutationLocationUpdateArgs = {
  uniqueInput: LocationUniqueInput;
  updateInput: LocationUpdateUniput;
};

export enum PriceVatType {
  ExcludedVat = 'excluded_vat',
  IncludedVat = 'included_vat'
}

export enum PurchaseDocumentType {
  PurchaseOrder = 'purchase_order',
  PurchaseReturn = 'purchase_return'
}

export type PurchaseItemInput = {
  additional_discount?: InputMaybe<Scalars['Float']['input']>;
  barcode: Scalars['String']['input'];
  discount?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  item_desc?: InputMaybe<Scalars['String']['input']>;
  item_id: Scalars['Int']['input'];
  item_img_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  item_name: Scalars['String']['input'];
  item_unique_id: Scalars['String']['input'];
  net_amount?: InputMaybe<Scalars['Float']['input']>;
  po_qty?: InputMaybe<Scalars['Float']['input']>;
  post_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_discount_amount?: InputMaybe<Scalars['Float']['input']>;
  pre_vat_amount?: InputMaybe<Scalars['Float']['input']>;
  price_per_unit?: InputMaybe<Scalars['Float']['input']>;
  qty: Scalars['Float']['input'];
  qty_issued?: InputMaybe<Scalars['Float']['input']>;
  qty_ordered?: InputMaybe<Scalars['Float']['input']>;
  qty_received?: InputMaybe<Scalars['Float']['input']>;
  qty_returned?: InputMaybe<Scalars['Float']['input']>;
  reference_document_type?: InputMaybe<ReferenceDocumentType>;
  reference_line_item?: InputMaybe<Scalars['Json']['input']>;
  reference_unique_id: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  rs_qty?: InputMaybe<Scalars['Float']['input']>;
  stock_qty?: InputMaybe<Scalars['Int']['input']>;
  total_amount?: InputMaybe<Scalars['Float']['input']>;
  traceability: Traceability;
  unique_id: Scalars['String']['input'];
  uom?: InputMaybe<Scalars['Json']['input']>;
  uom_conversion_list?: InputMaybe<Array<InputMaybe<Scalars['Json']['input']>>>;
  uom_id?: InputMaybe<Scalars['Int']['input']>;
  uom_name?: InputMaybe<Scalars['String']['input']>;
  vat_amount?: InputMaybe<Scalars['Float']['input']>;
  vat_percentage?: InputMaybe<Scalars['String']['input']>;
  wait_receive_qty?: InputMaybe<Scalars['Float']['input']>;
  withholding_tax_type?: InputMaybe<Scalars['String']['input']>;
  withholding_tax_value?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchaseItemList = {
  __typename?: 'PurchaseItemList';
  additional_discount?: Maybe<Scalars['Float']['output']>;
  barcode: Scalars['String']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item_desc?: Maybe<Scalars['String']['output']>;
  item_id: Scalars['Int']['output'];
  item_img_url?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  item_name: Scalars['String']['output'];
  item_unique_id: Scalars['String']['output'];
  net_amount?: Maybe<Scalars['Float']['output']>;
  po_qty?: Maybe<Scalars['Float']['output']>;
  post_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_discount_amount?: Maybe<Scalars['Float']['output']>;
  pre_vat_amount?: Maybe<Scalars['Float']['output']>;
  price_per_unit?: Maybe<Scalars['Float']['output']>;
  qty: Scalars['Float']['output'];
  qty_issued?: Maybe<Scalars['Float']['output']>;
  qty_ordered?: Maybe<Scalars['Float']['output']>;
  qty_received?: Maybe<Scalars['Float']['output']>;
  qty_returned?: Maybe<Scalars['Float']['output']>;
  reference_document_type?: Maybe<ReferenceDocumentType>;
  reference_line_item?: Maybe<Scalars['Json']['output']>;
  reference_unique_id: Scalars['String']['output'];
  remark?: Maybe<Scalars['String']['output']>;
  rs_qty?: Maybe<Scalars['Float']['output']>;
  stock_qty?: Maybe<Scalars['Int']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
  traceability?: Maybe<Traceability>;
  unique_id: Scalars['String']['output'];
  uom?: Maybe<Scalars['Json']['output']>;
  uom_conversion_list?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  uom_id?: Maybe<Scalars['Int']['output']>;
  uom_name?: Maybe<Scalars['String']['output']>;
  vat_amount?: Maybe<Scalars['Float']['output']>;
  vat_percentage?: Maybe<Scalars['String']['output']>;
  wait_receive_qty?: Maybe<Scalars['Float']['output']>;
  withholding_tax_type?: Maybe<Scalars['String']['output']>;
  withholding_tax_value?: Maybe<Scalars['Float']['output']>;
};

export type PurchaseUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  ContactFindUnique?: Maybe<Contact>;
  ContactViewAggrid: ContactViewAggrid;
  ContactsFindManyAggrid: ContactAggrid;
  CurrentImportRequest?: Maybe<Scalars['Json']['output']>;
  GenerateReportContactNoQueue?: Maybe<Scalars['String']['output']>;
  GenerateReportLocationNoQueue?: Maybe<Scalars['String']['output']>;
  HistoryImportRequest?: Maybe<Scalars['Json']['output']>;
  LocationFindUnique?: Maybe<Location>;
  LocationViewAggrid: LocationViewAggrid;
  LocationsFindManyAggrid: LocationAggrid;
  RecentHistoryImportRequest?: Maybe<Scalars['Json']['output']>;
  UniqueIdGenerate: Scalars['String']['output'];
  UniqueIdIsExist: Scalars['Boolean']['output'];
  ValidateContactImport: ValidateContactImportResult;
  ValidateLocationImport: ValidateLocationImportResult;
};


export type QueryContactFindUniqueArgs = {
  uniqueInput?: InputMaybe<ContactUniqueInput>;
};


export type QueryContactViewAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryContactsFindManyAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryGenerateReportContactNoQueueArgs = {
  input?: InputMaybe<ReportContactGenerateInput>;
};


export type QueryGenerateReportLocationNoQueueArgs = {
  input?: InputMaybe<ReportLocationGenerateInput>;
};


export type QueryLocationFindUniqueArgs = {
  uniqueInput?: InputMaybe<LocationUniqueInput>;
};


export type QueryLocationViewAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryLocationsFindManyAggridArgs = {
  aggridInput?: InputMaybe<Scalars['AnyAggridInput']['input']>;
};


export type QueryUniqueIdGenerateArgs = {
  modelType: ContactModelType;
};


export type QueryUniqueIdIsExistArgs = {
  modelType: ContactModelType;
  uniqueId: Scalars['String']['input'];
};


export type QueryValidateContactImportArgs = {
  validateInput: ValidateContactImportInput;
};


export type QueryValidateLocationImportArgs = {
  validateInput: ValidateLocationImportInput;
};

export type ReferenceDocumentList = {
  __typename?: 'ReferenceDocumentList';
  document_id?: Maybe<Scalars['Int']['output']>;
  document_type?: Maybe<PurchaseDocumentType>;
  document_unique_id?: Maybe<Scalars['String']['output']>;
};

export type ReferenceDocumentListInput = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  document_type?: InputMaybe<PurchaseDocumentType>;
  document_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export enum ReferenceDocumentType {
  PurchaseOrder = 'purchase_order',
  PurchaseReturn = 'purchase_return'
}

export type RelatedUser = {
  __typename?: 'RelatedUser';
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  title_name?: Maybe<Scalars['String']['output']>;
  user_unique_id?: Maybe<Scalars['String']['output']>;
};

export type RelatedUserList = {
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  is_active?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  title_name?: InputMaybe<Scalars['String']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ReportContactGenerateInput = {
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  report_type: ContactReportType;
  start_date?: InputMaybe<Scalars['DateTime']['input']>;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ReportLocationGenerateInput = {
  params?: InputMaybe<Scalars['Json']['input']>;
  report_type: LocationReportType;
  user_unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type ReportResult = {
  __typename?: 'ReportResult';
  detail?: Maybe<Scalars['Json']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type SalesCustomerInputObject = {
  billing_address?: InputMaybe<AddressInputObject>;
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_unique_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  identity_no?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SalesCustomerObject = {
  __typename?: 'SalesCustomerObject';
  billing_address?: Maybe<AddressObject>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_unique_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  identity_no?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type SalesPersonInputObject = {
  department?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  img_url?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  nick_name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['Int']['input'];
  title_name?: InputMaybe<Scalars['String']['input']>;
  unique_id?: InputMaybe<Scalars['String']['input']>;
};

export type SalesPersonObject = {
  __typename?: 'SalesPersonObject';
  department?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  img_url?: Maybe<Array<Scalars['String']['output']>>;
  last_name?: Maybe<Scalars['String']['output']>;
  nick_name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  title_name?: Maybe<Scalars['String']['output']>;
  unique_id?: Maybe<Scalars['String']['output']>;
};

export type SelectOptionById = {
  __typename?: 'SelectOptionById';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type ShippingCost = {
  __typename?: 'ShippingCost';
  cost?: Maybe<Scalars['Float']['output']>;
  is_frozen: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type ShippingCostInputObject = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  is_frozen: Scalars['Boolean']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SpectaQlOption = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Tag = {
  __typename?: 'Tag';
  document_type: TagDocumentType;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum TagDocumentType {
  Batch = 'batch',
  CashSales = 'cash_sales',
  Contact = 'contact',
  CreditNote = 'credit_note',
  CustomerDeposit = 'customer_deposit',
  DeliveryOrder = 'delivery_order',
  DeliveryTrip = 'delivery_trip',
  Employee = 'employee',
  Event = 'event',
  GoodsAdjust = 'goods_adjust',
  GoodsIssue = 'goods_issue',
  GoodsReceive = 'goods_receive',
  GoodsTransfer = 'goods_transfer',
  Inventory = 'inventory',
  Item = 'item',
  PaymentMade = 'payment_made',
  PaymentReceive = 'payment_receive',
  Project = 'project',
  Promotion = 'promotion',
  Purchase = 'purchase',
  PurchaseInvoice = 'purchase_invoice',
  PurchaseOrder = 'purchase_order',
  PurchaseRequest = 'purchase_request',
  PurchaseReturn = 'purchase_return',
  Quotation = 'quotation',
  Role = 'role',
  Sale = 'sale',
  SalesInvoice = 'sales_invoice',
  SalesOrder = 'sales_order',
  SalesReturn = 'sales_return',
  Serial = 'serial',
  Task = 'task'
}

export enum Traceability {
  Lot = 'lot',
  Normal = 'normal',
  Serial = 'serial'
}

export type ValidateContactImportInput = {
  contact_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  import_mode: ContactImportMode;
};

export type ValidateContactImportResult = {
  __typename?: 'ValidateContactImportResult';
  existing_contact_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_contact_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
};

export type ValidateLocationImportInput = {
  contact_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
  import_mode: LocationImportMode;
  location_unique_id_list?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ValidateLocationImportResult = {
  __typename?: 'ValidateLocationImportResult';
  existing_contact_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  existing_location_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_contact_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
  missing_location_unique_id_list?: Maybe<Array<Scalars['String']['output']>>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  unique_id: Scalars['String']['output'];
  warehouse_level_1_list?: Maybe<Array<WarehouseLevel1>>;
};

export type WarehouseLevel1 = {
  __typename?: 'WarehouseLevel1';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse: Warehouse;
  warehouse_level_2_list?: Maybe<Array<WarehouseLevel2>>;
};

export type WarehouseLevel2 = {
  __typename?: 'WarehouseLevel2';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse_level_1: WarehouseLevel1;
  warehouse_level_3_list?: Maybe<Array<WarehouseLevel3>>;
};

export type WarehouseLevel3 = {
  __typename?: 'WarehouseLevel3';
  bin_location_list?: Maybe<Array<BinLocation>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  warehouse_level_2: WarehouseLevel2;
};

export type ContactCreateMutationVariables = Exact<{
  createInput: ContactCreateInput;
}>;


export type ContactCreateMutation = { __typename?: 'Mutation', ContactCreate?: { __typename?: 'Contact', id: number, unique_id: string, is_supplier: boolean, is_customer: boolean, img_url?: Array<string> | null, created_date: any, business_type?: string | null, business_type_detail?: string | null, title_name?: string | null, name?: string | null, last_name?: string | null, nick_name?: string | null, taxpayer_id?: string | null, registered_capital?: number | null, source?: string | null, status?: number | null, remark_status?: string | null, payment_type_list?: Array<string> | null, payment_duration?: number | null, payment_credit_duration?: number | null, payment_contact_person?: string | null, payment_contact_phone?: string | null, billing_note_duration?: number | null, billing_note_contact_person?: string | null, billing_note_contact_phone?: string | null, account_debtor?: string | null, account_creditor?: string | null, credit_request?: number | null, credit_request_duration?: number | null, required_purchase_item_type?: Array<string> | null, purchase_amount_per_month?: number | null, remark?: string | null, contact_channel_list?: Array<{ __typename?: 'ContactChannelObject', contact_channel_info?: string | null, contact_channel_type?: string | null }> | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, address_list?: Array<{ __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null }> | null, contact_person_list?: Array<{ __typename?: 'ContactPersonObject', img_url?: Array<string> | null, title_name?: string | null, first_name?: string | null, last_name?: string | null, nick_name?: string | null, position?: string | null, remark?: string | null, contact_channel_list?: Array<{ __typename?: 'ContactChannelObject', contact_channel_info?: string | null, contact_channel_type?: string | null }> | null }> | null, bank_account_detail_list?: Array<{ __typename?: 'BankAccountDetailObject', provider?: string | null, type?: string | null, name?: string | null, account_number?: string | null, branch?: string | null, description?: string | null }> | null, attachment_list?: Array<{ __typename?: 'AttachmentObject', attachment_name?: string | null, uploaded_date?: any | null, url?: string | null, uploaded_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null }> | null, sales_person_list?: Array<{ __typename?: 'SalesPersonObject', unique_id?: string | null, img_url?: Array<string> | null, title_name?: string | null, nick_name?: string | null, first_name?: string | null, last_name?: string | null, department?: string | null, position?: string | null, status: number }> | null } | null };

export type ContactDeleteMutationVariables = Exact<{
  uniqueInput: ContactUniqueInput;
}>;


export type ContactDeleteMutation = { __typename?: 'Mutation', ContactDelete?: { __typename?: 'Contact', id: number, name?: string | null, unique_id: string } | null };

export type ContactFindUniqueQueryVariables = Exact<{
  uniqueInput?: InputMaybe<ContactUniqueInput>;
}>;


export type ContactFindUniqueQuery = { __typename?: 'Query', ContactFindUnique?: { __typename?: 'Contact', id: number, unique_id: string, is_supplier: boolean, is_customer: boolean, img_url?: Array<string> | null, created_date: any, business_type?: string | null, business_type_detail?: string | null, title_name?: string | null, name?: string | null, last_name?: string | null, nick_name?: string | null, taxpayer_id?: string | null, registered_capital?: number | null, source?: string | null, status?: number | null, remark_status?: string | null, payment_type_list?: Array<string> | null, payment_duration?: number | null, payment_credit_duration?: number | null, payment_contact_person?: string | null, payment_contact_phone?: string | null, billing_note_duration?: number | null, billing_note_contact_person?: string | null, billing_note_contact_phone?: string | null, account_debtor?: string | null, account_creditor?: string | null, credit_request?: number | null, credit_request_duration?: number | null, required_purchase_item_type?: Array<string> | null, purchase_amount_per_month?: number | null, remark?: string | null, contact_channel_list?: Array<{ __typename?: 'ContactChannelObject', contact_channel_info?: string | null, contact_channel_type?: string | null }> | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, address_list?: Array<{ __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null }> | null, contact_person_list?: Array<{ __typename?: 'ContactPersonObject', img_url?: Array<string> | null, title_name?: string | null, first_name?: string | null, last_name?: string | null, nick_name?: string | null, position?: string | null, remark?: string | null, contact_channel_list?: Array<{ __typename?: 'ContactChannelObject', contact_channel_info?: string | null, contact_channel_type?: string | null }> | null }> | null, bank_account_detail_list?: Array<{ __typename?: 'BankAccountDetailObject', provider?: string | null, type?: string | null, name?: string | null, account_number?: string | null, branch?: string | null, description?: string | null }> | null, attachment_list?: Array<{ __typename?: 'AttachmentObject', attachment_name?: string | null, uploaded_date?: any | null, url?: string | null, uploaded_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null }> | null, sales_person_list?: Array<{ __typename?: 'SalesPersonObject', unique_id?: string | null, img_url?: Array<string> | null, title_name?: string | null, nick_name?: string | null, first_name?: string | null, last_name?: string | null, department?: string | null, position?: string | null, status: number }> | null } | null };

export type ContactUpdateMutationVariables = Exact<{
  uniqueInput: ContactUniqueInput;
  updateInput: ContactUpdateUniput;
}>;


export type ContactUpdateMutation = { __typename?: 'Mutation', ContactUpdate?: { __typename?: 'Contact', id: number, unique_id: string, is_supplier: boolean, is_customer: boolean, img_url?: Array<string> | null, created_date: any, business_type?: string | null, business_type_detail?: string | null, title_name?: string | null, name?: string | null, last_name?: string | null, nick_name?: string | null, taxpayer_id?: string | null, registered_capital?: number | null, source?: string | null, status?: number | null, remark_status?: string | null, payment_type_list?: Array<string> | null, payment_duration?: number | null, payment_credit_duration?: number | null, payment_contact_person?: string | null, payment_contact_phone?: string | null, billing_note_duration?: number | null, billing_note_contact_person?: string | null, billing_note_contact_phone?: string | null, account_debtor?: string | null, account_creditor?: string | null, credit_request?: number | null, credit_request_duration?: number | null, required_purchase_item_type?: Array<string> | null, purchase_amount_per_month?: number | null, remark?: string | null, contact_channel_list?: Array<{ __typename?: 'ContactChannelObject', contact_channel_info?: string | null, contact_channel_type?: string | null }> | null, tag_list?: Array<{ __typename?: 'Tag', document_type: TagDocumentType, id: number, name: string }> | null, address_list?: Array<{ __typename?: 'AddressObject', is_default?: boolean | null, is_same_as_default_address?: boolean | null, address_type?: string | null, address_contact_name?: string | null, address_contact_phone?: string | null, address_contact_fax?: string | null, name?: string | null, sub_district?: string | null, district?: string | null, province?: string | null, postal_code?: string | null, country?: string | null }> | null, contact_person_list?: Array<{ __typename?: 'ContactPersonObject', img_url?: Array<string> | null, title_name?: string | null, first_name?: string | null, last_name?: string | null, nick_name?: string | null, position?: string | null, remark?: string | null, contact_channel_list?: Array<{ __typename?: 'ContactChannelObject', contact_channel_info?: string | null, contact_channel_type?: string | null }> | null }> | null, bank_account_detail_list?: Array<{ __typename?: 'BankAccountDetailObject', provider?: string | null, type?: string | null, name?: string | null, account_number?: string | null, branch?: string | null, description?: string | null }> | null, attachment_list?: Array<{ __typename?: 'AttachmentObject', attachment_name?: string | null, uploaded_date?: any | null, url?: string | null, uploaded_by?: { __typename?: 'CreatorObject', user_id?: number | null, user_unique_id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, img_url?: Array<string> | null } | null }> | null, sales_person_list?: Array<{ __typename?: 'SalesPersonObject', unique_id?: string | null, img_url?: Array<string> | null, title_name?: string | null, nick_name?: string | null, first_name?: string | null, last_name?: string | null, department?: string | null, position?: string | null, status: number }> | null } | null };

export type CrmUniqueIdGenerateQueryVariables = Exact<{
  modelType: ContactModelType;
}>;


export type CrmUniqueIdGenerateQuery = { __typename?: 'Query', UniqueIdGenerate: string };

export type GenerateContactReportQueryVariables = Exact<{
  input?: InputMaybe<ReportContactGenerateInput>;
}>;


export type GenerateContactReportQuery = { __typename?: 'Query', GenerateReportContactNoQueue?: string | null };

export type GenerateLocationReportQueryVariables = Exact<{
  input?: InputMaybe<ReportLocationGenerateInput>;
}>;


export type GenerateLocationReportQuery = { __typename?: 'Query', GenerateReportLocationNoQueue?: string | null };

export type ImportContactMutationVariables = Exact<{
  importInput: ContactImportInput;
}>;


export type ImportContactMutation = { __typename?: 'Mutation', ImportContact: { __typename?: 'ContactImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, detail?: any | null } };

export type ImportLocationMutationVariables = Exact<{
  importInput: LocationImportInput;
}>;


export type ImportLocationMutation = { __typename?: 'Mutation', ImportLocation: { __typename?: 'LocationImportResult', success: boolean, timestamp?: any | null, status?: string | null, message?: string | null, detail?: any | null } };

export type ValidateContactImportQueryVariables = Exact<{
  validateInput: ValidateContactImportInput;
}>;


export type ValidateContactImportQuery = { __typename?: 'Query', ValidateContactImport: { __typename?: 'ValidateContactImportResult', existing_contact_unique_id_list?: Array<string> | null, missing_contact_unique_id_list?: Array<string> | null } };

export type ValidateLocationImportQueryVariables = Exact<{
  validateInput: ValidateLocationImportInput;
}>;


export type ValidateLocationImportQuery = { __typename?: 'Query', ValidateLocationImport: { __typename?: 'ValidateLocationImportResult', existing_location_unique_id_list?: Array<string> | null, missing_location_unique_id_list?: Array<string> | null, existing_contact_unique_id_list?: Array<string> | null, missing_contact_unique_id_list?: Array<string> | null } };


export const ContactCreateDocument = `
    mutation ContactCreate($createInput: ContactCreateInput!) {
  ContactCreate(createInput: $createInput) {
    id
    unique_id
    is_supplier
    is_customer
    img_url
    created_date
    business_type
    business_type_detail
    title_name
    name
    last_name
    nick_name
    taxpayer_id
    registered_capital
    source
    contact_channel_list {
      contact_channel_info
      contact_channel_type
    }
    status
    remark_status
    tag_list {
      document_type
      id
      name
    }
    address_list {
      is_default
      is_same_as_default_address
      address_type
      address_contact_name
      address_contact_phone
      address_contact_fax
      name
      sub_district
      district
      province
      postal_code
      country
    }
    contact_person_list {
      img_url
      title_name
      first_name
      last_name
      nick_name
      position
      remark
      contact_channel_list {
        contact_channel_info
        contact_channel_type
      }
    }
    payment_type_list
    payment_duration
    payment_credit_duration
    payment_contact_person
    payment_contact_phone
    bank_account_detail_list {
      provider
      type
      name
      account_number
      branch
      description
    }
    billing_note_duration
    billing_note_contact_person
    billing_note_contact_phone
    account_debtor
    account_creditor
    credit_request
    credit_request_duration
    required_purchase_item_type
    purchase_amount_per_month
    attachment_list {
      attachment_name
      uploaded_by {
        user_id
        user_unique_id
        first_name
        last_name
        email
        img_url
      }
      uploaded_date
      url
    }
    sales_person_list {
      unique_id
      img_url
      title_name
      nick_name
      first_name
      last_name
      department
      position
      status
    }
    remark
  }
}
    `;
export const useContactCreateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ContactCreateMutation, TError, ContactCreateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ContactCreateMutation, TError, ContactCreateMutationVariables, TContext>(
      ['ContactCreate'],
      (variables?: ContactCreateMutationVariables) => fetcher<ContactCreateMutation, ContactCreateMutationVariables>(client, ContactCreateDocument, variables, headers)(),
      options
    );
export const ContactDeleteDocument = `
    mutation ContactDelete($uniqueInput: ContactUniqueInput!) {
  ContactDelete(uniqueInput: $uniqueInput) {
    id
    name
    unique_id
  }
}
    `;
export const useContactDeleteMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ContactDeleteMutation, TError, ContactDeleteMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ContactDeleteMutation, TError, ContactDeleteMutationVariables, TContext>(
      ['ContactDelete'],
      (variables?: ContactDeleteMutationVariables) => fetcher<ContactDeleteMutation, ContactDeleteMutationVariables>(client, ContactDeleteDocument, variables, headers)(),
      options
    );
export const ContactFindUniqueDocument = `
    query ContactFindUnique($uniqueInput: ContactUniqueInput) {
  ContactFindUnique(uniqueInput: $uniqueInput) {
    id
    unique_id
    is_supplier
    is_customer
    img_url
    created_date
    business_type
    business_type_detail
    title_name
    name
    last_name
    nick_name
    taxpayer_id
    registered_capital
    source
    contact_channel_list {
      contact_channel_info
      contact_channel_type
    }
    status
    remark_status
    tag_list {
      document_type
      id
      name
    }
    address_list {
      is_default
      is_same_as_default_address
      address_type
      address_contact_name
      address_contact_phone
      address_contact_fax
      name
      sub_district
      district
      province
      postal_code
      country
    }
    contact_person_list {
      img_url
      title_name
      first_name
      last_name
      nick_name
      position
      remark
      contact_channel_list {
        contact_channel_info
        contact_channel_type
      }
    }
    payment_type_list
    payment_duration
    payment_credit_duration
    payment_contact_person
    payment_contact_phone
    bank_account_detail_list {
      provider
      type
      name
      account_number
      branch
      description
    }
    billing_note_duration
    billing_note_contact_person
    billing_note_contact_phone
    account_debtor
    account_creditor
    credit_request
    credit_request_duration
    required_purchase_item_type
    purchase_amount_per_month
    attachment_list {
      attachment_name
      uploaded_by {
        user_id
        user_unique_id
        first_name
        last_name
        email
        img_url
      }
      uploaded_date
      url
    }
    sales_person_list {
      unique_id
      img_url
      title_name
      nick_name
      first_name
      last_name
      department
      position
      status
    }
    remark
  }
}
    `;
export const useContactFindUniqueQuery = <
      TData = ContactFindUniqueQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ContactFindUniqueQueryVariables,
      options?: UseQueryOptions<ContactFindUniqueQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ContactFindUniqueQuery, TError, TData>(
      variables === undefined ? ['ContactFindUnique'] : ['ContactFindUnique', variables],
      fetcher<ContactFindUniqueQuery, ContactFindUniqueQueryVariables>(client, ContactFindUniqueDocument, variables, headers),
      options
    );
export const ContactUpdateDocument = `
    mutation ContactUpdate($uniqueInput: ContactUniqueInput!, $updateInput: ContactUpdateUniput!) {
  ContactUpdate(uniqueInput: $uniqueInput, updateInput: $updateInput) {
    id
    unique_id
    is_supplier
    is_customer
    img_url
    created_date
    business_type
    business_type_detail
    title_name
    name
    last_name
    nick_name
    taxpayer_id
    registered_capital
    source
    contact_channel_list {
      contact_channel_info
      contact_channel_type
    }
    status
    remark_status
    tag_list {
      document_type
      id
      name
    }
    address_list {
      is_default
      is_same_as_default_address
      address_type
      address_contact_name
      address_contact_phone
      address_contact_fax
      name
      sub_district
      district
      province
      postal_code
      country
    }
    contact_person_list {
      img_url
      title_name
      first_name
      last_name
      nick_name
      position
      remark
      contact_channel_list {
        contact_channel_info
        contact_channel_type
      }
    }
    payment_type_list
    payment_duration
    payment_credit_duration
    payment_contact_person
    payment_contact_phone
    bank_account_detail_list {
      provider
      type
      name
      account_number
      branch
      description
    }
    billing_note_duration
    billing_note_contact_person
    billing_note_contact_phone
    account_debtor
    account_creditor
    credit_request
    credit_request_duration
    required_purchase_item_type
    purchase_amount_per_month
    attachment_list {
      attachment_name
      uploaded_by {
        user_id
        user_unique_id
        first_name
        last_name
        email
        img_url
      }
      uploaded_date
      url
    }
    sales_person_list {
      unique_id
      img_url
      title_name
      nick_name
      first_name
      last_name
      department
      position
      status
    }
    remark
  }
}
    `;
export const useContactUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ContactUpdateMutation, TError, ContactUpdateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ContactUpdateMutation, TError, ContactUpdateMutationVariables, TContext>(
      ['ContactUpdate'],
      (variables?: ContactUpdateMutationVariables) => fetcher<ContactUpdateMutation, ContactUpdateMutationVariables>(client, ContactUpdateDocument, variables, headers)(),
      options
    );
export const CrmUniqueIdGenerateDocument = `
    query CrmUniqueIdGenerate($modelType: ContactModelType!) {
  UniqueIdGenerate(modelType: $modelType)
}
    `;
export const useCrmUniqueIdGenerateQuery = <
      TData = CrmUniqueIdGenerateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CrmUniqueIdGenerateQueryVariables,
      options?: UseQueryOptions<CrmUniqueIdGenerateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CrmUniqueIdGenerateQuery, TError, TData>(
      ['CrmUniqueIdGenerate', variables],
      fetcher<CrmUniqueIdGenerateQuery, CrmUniqueIdGenerateQueryVariables>(client, CrmUniqueIdGenerateDocument, variables, headers),
      options
    );
export const GenerateContactReportDocument = `
    query GenerateContactReport($input: ReportContactGenerateInput) {
  GenerateReportContactNoQueue(input: $input)
}
    `;
export const useGenerateContactReportQuery = <
      TData = GenerateContactReportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GenerateContactReportQueryVariables,
      options?: UseQueryOptions<GenerateContactReportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GenerateContactReportQuery, TError, TData>(
      variables === undefined ? ['GenerateContactReport'] : ['GenerateContactReport', variables],
      fetcher<GenerateContactReportQuery, GenerateContactReportQueryVariables>(client, GenerateContactReportDocument, variables, headers),
      options
    );
export const GenerateLocationReportDocument = `
    query GenerateLocationReport($input: ReportLocationGenerateInput) {
  GenerateReportLocationNoQueue(input: $input)
}
    `;
export const useGenerateLocationReportQuery = <
      TData = GenerateLocationReportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GenerateLocationReportQueryVariables,
      options?: UseQueryOptions<GenerateLocationReportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GenerateLocationReportQuery, TError, TData>(
      variables === undefined ? ['GenerateLocationReport'] : ['GenerateLocationReport', variables],
      fetcher<GenerateLocationReportQuery, GenerateLocationReportQueryVariables>(client, GenerateLocationReportDocument, variables, headers),
      options
    );
export const ImportContactDocument = `
    mutation ImportContact($importInput: ContactImportInput!) {
  ImportContact(importInput: $importInput) {
    success
    timestamp
    status
    message
    detail
  }
}
    `;
export const useImportContactMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportContactMutation, TError, ImportContactMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportContactMutation, TError, ImportContactMutationVariables, TContext>(
      ['ImportContact'],
      (variables?: ImportContactMutationVariables) => fetcher<ImportContactMutation, ImportContactMutationVariables>(client, ImportContactDocument, variables, headers)(),
      options
    );
export const ImportLocationDocument = `
    mutation ImportLocation($importInput: LocationImportInput!) {
  ImportLocation(importInput: $importInput) {
    success
    timestamp
    status
    message
    detail
  }
}
    `;
export const useImportLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ImportLocationMutation, TError, ImportLocationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ImportLocationMutation, TError, ImportLocationMutationVariables, TContext>(
      ['ImportLocation'],
      (variables?: ImportLocationMutationVariables) => fetcher<ImportLocationMutation, ImportLocationMutationVariables>(client, ImportLocationDocument, variables, headers)(),
      options
    );
export const ValidateContactImportDocument = `
    query ValidateContactImport($validateInput: ValidateContactImportInput!) {
  ValidateContactImport(validateInput: $validateInput) {
    existing_contact_unique_id_list
    missing_contact_unique_id_list
  }
}
    `;
export const useValidateContactImportQuery = <
      TData = ValidateContactImportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ValidateContactImportQueryVariables,
      options?: UseQueryOptions<ValidateContactImportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ValidateContactImportQuery, TError, TData>(
      ['ValidateContactImport', variables],
      fetcher<ValidateContactImportQuery, ValidateContactImportQueryVariables>(client, ValidateContactImportDocument, variables, headers),
      options
    );
export const ValidateLocationImportDocument = `
    query ValidateLocationImport($validateInput: ValidateLocationImportInput!) {
  ValidateLocationImport(validateInput: $validateInput) {
    existing_location_unique_id_list
    missing_location_unique_id_list
    existing_contact_unique_id_list
    missing_contact_unique_id_list
  }
}
    `;
export const useValidateLocationImportQuery = <
      TData = ValidateLocationImportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ValidateLocationImportQueryVariables,
      options?: UseQueryOptions<ValidateLocationImportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ValidateLocationImportQuery, TError, TData>(
      ['ValidateLocationImport', variables],
      fetcher<ValidateLocationImportQuery, ValidateLocationImportQueryVariables>(client, ValidateLocationImportDocument, variables, headers),
      options
    );